import { useQuery } from "@tanstack/react-query";
import axios from "axios";

const useFetchObject = (queryKey, endpoint, id, token) => {
  const fetchFunction = async () => {
    const headers = token ? { Authorization: `Token ${token}` } : {};
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/${endpoint}/${id}/`,
      {
        headers,
      }
    );
    return response.data;
  };

  const { data, isLoading, isError, isSuccess, error, refetch } = useQuery({
    queryKey: [queryKey],
    queryFn: fetchFunction,
  });

  return { data, isLoading, isError, isSuccess, error, refetch };
};

export default useFetchObject;
